import { render } from "./PropertyList.vue?vue&type=template&id=3978442b&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"

import "./PropertyList.vue?vue&type=style&index=0&id=3978442b&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3978442b"]])

export default __exports__